import { render, staticRenderFns } from "./igt-action.vue?vue&type=template&id=371eaeed&scoped=true&"
import script from "./igt-action.vue?vue&type=script&lang=js&"
export * from "./igt-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371eaeed",
  null
  
)

export default component.exports